import {PanelConfigurationIndicators} from './panelConfigurationIndicators.model';
import {Indicator} from '../report/indicator.model';

export class GroupingIndicatorsItems {
  groupingConfiguration: string;
  indicators: Array<Indicator>;
}

export class GroupingIndicators {
  panelConfigurationIndicators: PanelConfigurationIndicators;
  groupingIndicatorsItems: Array<GroupingIndicatorsItems>;
}
